<template>
    <div id="page-top" class="row">
        <div class="apply-admission">
            <div class="apply-admission-wrap bg-dark accent-primary-bs bd-type1 accent-primary-bd">
                <div class="apply-admission-inner">
                    <h2 class="title text-center">
                        <span>Register</span>
                    </h2>
                    <div class="caption text-center">
                        Let's get you started!
                    </div>
                    <div>
                        <br />
                        <div>
                            <div class="form-sent-main">
                                <input :class="{ 'not-valid': v_firstName }" v-model="firstName" type="text" placeholder="First Name">
                            </div>
                        </div>
                        <div class="apply-sent apply-sent-style1" style="padding-top:20px">
                            <div class="form-sent-main">
                                <input :class="{ 'not-valid': v_lastName }" v-model="lastName" type="text" placeholder="Last Name">
                            </div>
                        </div>
                        <div class="apply-sent apply-sent-style1" style="padding-top:20px" v-if="hasProperty('IdNumber')">
                            <div class="form-sent-main" style="position: relative;">
                                <input :class="{ 'not-valid': v_idNumber }" v-model="idNumber" type="text" placeholder="ID Number">
                                <div class="tooltip-icon" data-toggle="tooltip" data-placement="top" title="ID Number is displayed on issued certificates" style="color: white; position: absolute; right: -30px; top: 0; width: fit-content;">
                                    <i class="fa fa-info-circle"></i>
                                </div>
                            </div>
                        </div>
                        <div class="apply-sent apply-sent-style1" style="padding-top:20px" v-if="hasProperty('HostEmail')">
                            <div class="form-sent-main" style="position: relative;">
                                <input :class="{ 'not-valid': v_hostEmail }" v-model="hostEmail" type="text" placeholder="Host Email Address">
                                <div class="tooltip-icon" data-toggle="tooltip" data-placement="top" title="The email address of your host" style="color: white; position: absolute; right: -30px; top: 0; width: fit-content;">
                                    <i class="fa fa-info-circle"></i>
                                </div>
                            </div>
                        </div>
                        <div class="apply-sent apply-sent-style1" style="padding-top:20px" v-if="hasProperty('CompanyRepresenting')">
                            <div class="form-sent-main" style="position: relative;">
                                <input :class="{ 'not-valid': v_companyRepresenting }" v-model="companyRepresenting" type="text" placeholder="Company Representing">
                                <div class="tooltip-icon" data-toggle="tooltip" data-placement="top" title="The company you're representing" style="color: white; position: absolute; right: -30px; top: 0; width: fit-content;">
                                    <i class="fa fa-info-circle"></i>
                                </div>
                            </div>
                        </div>
                        <div class="apply-sent apply-sent-style1" style="padding-top:20px" v-if="hasDivisions()">
                            <div class="form-sent-main">
                                <select v-model="division" :class="{ 'not-valid': v_division }" style="border-radius: 20px 20px 20px 20px; color:#a9a5a5">
                                    <option value="" disabled selected>
                                        Select a division
                                    </option>
                                    <option v-for="division in divisions" :value="division">{{ division }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="apply-sent apply-sent-style1" style="padding-top:20px">
                        <div class="form-sent-main">
                            <input :class="{ 'not-valid': v_email }" v-model="email" type="text" placeholder="Email address">
                        </div>
                    </div>
                    <div class="apply-sent apply-sent-style1" style="padding-top:20px">
                        <div class="form-sent-main">
                            <input :class="{ 'not-valid' : v_password }" v-model="password" type="password" placeholder="Password">
                        </div>
                        <div style="text-align: center;">
                            <label class="checkbox-inline tc-label">
                                <input :class="{ 'not-valid' : v_terms }" v-model="terms" type="checkbox" value="check"> I agree to the
                                <a v-if="siteDesign.footer.termsFileName !== ''" target="_blank" :href="siteDesign.footer | s3url('terms')">Terms and Conditions of Use.</a>
                            </label>
                        </div>
                        <div style="text-align: center; margin-top: 25px">
                            <button v-on:click="register" class="sign-up-main btn-site-primary" href="#loader-modal" data-toggle="modal">Register!</button>
                        </div>
                    </div>
                </div>
                <br />
                <div v-if="v_summary" class="alert alert-danger" style="text-align: center;">
                    {{ v_summary }}
                </div>
                <div class="caption text-center">
                    Forgot your password?
                    <br /><br />
                    <router-link class="register-link" to="/auth/forgot">Reset it here</router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>

    .tc-label {
        color: white;
        margin-top: 10px;
    }

    #page-top {
        background-image: url("/wwwroot/images/home/header9.jpg");
        background-repeat: no-repeat;
        background-size: cover;
    }

    .apply-admission {
        margin-top: 80px;
        left: 15%;
        position: relative;
        width: 70%;
        z-index: 100;
        margin-bottom: 20px;
    }

    .apply-admission-wrap {
        padding-top: 20px !important;
        padding-bottom: 20px !important;
    }

    .register-link {
        color: white;
        text-decoration: underline;
        font-size: 20px;
    }

    .not-valid {
        border-color: rgb(255, 95, 96);
        border-width: 3px;
    }

    .alert-danger {
        background-color: rgb(255, 95, 96);
        border-color: rgb(255, 95, 96);
        color: white;
    }
</style>
<script>
    export default {
        name: 'Register',
        components: {
        },
        data: function () {
            return {
                email: "",
                firstName: "",
                lastName: "",
                password: "",
                terms: "",
                idNumber: "",
                division: "",
                hostEmail: "",
                companyRepresenting: "",

                v_email: false,
                v_firstName: false,
                v_lastName: false,
                v_password: false,
                v_terms: false,
                v_idNumber: false,
                v_division: false,
                v_hostEmail: false,
                v_companyRepresenting: false,
                v_summary: ""
            }
        },
        methods: {
            validate: function () {
                this.v_firstName = false;
                this.v_lastName = false;
                this.v_email = false;
                this.v_password = false;
                this.v_idNumber = false;
                this.v_terms = false;
                this.v_hostEmail = false;
                this.v_companyRepresenting = false;
                this.v_division = false;
                this.v_summary = null;

                if (!this.isNotEmpty(this.firstName)) {
                    this.v_summary = "Please enter a valid first name";
                    this.v_firstName = true;
                    return false;
                }

                if (!this.isNotEmpty(this.idNumber)) {
                    var hasIdNumber = this.hasProperty("IdNumber");
                    if (hasIdNumber) {
                        this.v_summary = "Please enter a valid id number";
                        this.v_idNumber = true;
                        return false;
                    }
                }

                if (this.hasProperty("HostEmail")) {
                    if (!this.isValidEmail(this.hostEmail)) {
                        this.v_summary = "Please enter a valid host email address";
                        this.v_hostEmail = true;
                        return false;
                    }
                }

                if (this.hasProperty("CompanyRepresenting")) {
                    if (!this.isNotEmpty(this.companyRepresenting)) {
                        this.v_summary = "Please enter a valid company name";
                        this.v_companyRepresenting = true;
                        return false;
                    }
                }


                if (!this.isNotEmpty(this.lastName)) {
                    this.v_summary = "Please enter a valid last name";
                    this.v_lastName = true;
                    return false;
                }

                if (!this.isValidEmail(this.email)) {
                    this.v_summary = "Please enter a valid email address";
                    this.v_email = true;
                    return false;
                }

                if (!this.isValidPassword(this.password)) {
                    this.v_summary = "Please enter a valid password with at least 6 characters";
                    this.v_password = true;
                    return false;
                }

                if (!this.isValidTerms(this.terms)) {
                    this.v_summary = "Please accept the terms of use";
                    this.v_terms = true;
                    return false;
                }

                if (this.hasDivisions() && !this.division) {
                    this.v_summary = "Please select a division";
                    this.v_division = true;
                    return false;
                }

                return true;
            },
            async register() {
                try {
                    if (this.validate()) {
                        var userState = await this.web('/auth/register', "Setting up your account", {
                            firstName: this.firstName,
                            lastName: this.lastName,
                            email: this.email,
                            password: this.password,
                            idNumber: this.idNumber,
                            companyRepresenting: this.companyRepresenting,
                            hostEmail: this.hostEmail,
                            terms: this.terms,
                            division: this.division,
                        }, [400]);

                        //setting current user properties will log user in
                        this.$store.commit("setUserState", userState);
                    }
                }
                catch (e) {
                    if (e.response.status == 400) {
                        this.v_summary = e.response.data;
                    }
                }
            },
            hasProperty(property) {
                if (this.additionalProperties) {
                    var target = this.additionalProperties;
                    var result = target.includes(property);
                    return result;
                }
            },
            hasDivisions() {
                return this.divisions && this.divisions.length;
            }
        },
        computed: {
            siteDesign() {
                return this.$store.state.siteDesign;
            },
            additionalProperties() {
                return this.$store.state.additionalProperties;
            },
            divisions() {
                return this.$store.state.divisions;
            }
        },
        updated() {
            console.log("Update");
            $('[data-toggle="tooltip"]').tooltip()
        },
        mounted: function () {
            this.$store.commit("breadCrumbs", null);
            $("#page-top").css("background-image", "url(https://fabricfour.blob.core.windows.net/mhslearning-upload/" + this.siteDesign.homePage.bannerFileName + ")");
        }
    };
</script>
